import { useDisclosure } from "@mantine/hooks";
import { Modal, Button, Group, Loader } from "@mantine/core";
import trackerIcon from "../../images/tracker-modal-icon.png";
import useStyles from "./style.js";
import SelectCheckInType from "../SelectCheckInType/index.jsx";
import { useState  } from "react";
function ClockModal({
  startTimer,
  startCSS,
  btnName,
  setIsEnable,
  isEnable,
  handleSubmit,
  timerStart,
  stopTimer,
  handleClockOut,
  hardDisabled,
  selectedFacility,
  setSelectedFacility,
  selectedClient,
  setSelectedClient,
  startTime,
  endTime,
  stopTimerWithBreak,
  loading,
  setActive,
  selectedService,
  setSelectedService,
  break_Start
}) {
  const [opened_checkin_type, { close: close_checkin, open: open_checkin }] =
    useDisclosure(false);
  const [opened, { close, open }] = useDisclosure(false);
  const [disableClockBtn , setDisableClockBtn ] = useState(false)

  const handleModal = (value) => {
    if (value === "start break") {
      // handleClockOut("start-break");
      break_Start("start-break");
      stopTimerWithBreak();
      // stopTimer();
    } else if (value === "end break") {
      // handleSubmit();
      startTimer();
    } else if (value === "clock out") {
      handleClockOut("clock-out");
      setActive("active")
      stopTimer();
    } else if (value === "clock in") {
      handleSubmit();
      startTimer();
      setActive("inActive")
      close_checkin();
    }
    close();
  };

  const { classes } = useStyles();

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        size="auto"
        withCloseButton={false}
        centered
        zIndex={1000}
        overlayProps={{
          backgroundOpacity: 0.55,
          blur: 3,
        }}
      >
        <div className={classes.clockIconParent}>
          <img src={trackerIcon} alt="Tracker Icon" />
        </div>
        <h4 className={classes.modalHeading}>{`${btnName}?`}</h4>
        <p
          className={classes.warn}
        >{`Are you sure you want to ${btnName}? This section cannot be undone.`}</p>

        <Group mt="xl">
          <Button onClick={close} className={classes.cancelBtn}>
            Cancel
          </Button>
          <Button
            className={classes.action}
            onClick={() => handleModal(btnName)}
          >{`Yes, ${btnName}`}</Button>
        </Group>
      </Modal>

      <SelectCheckInType
        opened={opened_checkin_type}
        open={open_checkin}
        close={close_checkin}
        handleModal={handleModal}
        selectedFacility={selectedFacility}
        setSelectedFacility={setSelectedFacility}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        setDisableClockBtn={setDisableClockBtn}
        selectedService={selectedService}
        setSelectedService={setSelectedService}
      />

      <Button
        onClick={() => {
          setIsEnable(true);
          if (btnName === "clock out") {
            open();
          } else if (btnName === "clock in") {
            open_checkin();
          } else  {
            open();
          } 
        }}
          disabled={
            // (btnName === "clock in" && (!startTime || !endTime)) ||
            (disableClockBtn ? true : 
              hardDisabled === true || hardDisabled === false
              ? hardDisabled
              : btnName === "start break" && isEnable === false
              ? true
              : false || (btnName === "clock out" && isEnable === false)
              ? true
              : false || timerStart === true
              ? true 
              : false)
          }
        className={startCSS}
      >
        {loading ? <Loader color="yellow" size={18} style={{marginRight:'.5rem'}} /> : ''} <span>{btnName}</span>
      </Button>
    </>
  );
}

export default ClockModal;
